import { Component, OnInit, Input, OnDestroy, ViewChildren, ElementRef } from '@angular/core';
import { Observable, of, combineLatest, forkJoin, Subscription, empty } from "rxjs";
import { mergeMap, tap } from "rxjs/operators";
import { Note } from "../../../../common/models/note.model";
import { NoteType } from "../../../../common/models/note-type.enum";
import { Question, QuestionKind, Page } from "../../../models/flow.model";
import { ContextInteractionService } from "../../../../form-controls/services/context-interaction.service";
import { DomainDefinitionService } from "../../../../builder/services/domain-definition.service";
import { FlowOnBehalfService } from "../../../services/flow-on-behalf.service";
import { LunaDomain } from "../../../../builder/models/domain.model";
import { PageView, NoteView } from "../../../../common/models/flow.dto";

@Component({
    selector: 'clarification-notes',
    templateUrl: './clarification-notes.component.html',
    styleUrls: ['./clarification-notes.component.scss', '../../../../common/components/notes/notes.component.scss'],
    standalone: false
})
export class ClarificationNotesComponent implements OnInit, OnDestroy {

    @Input() instanceId: string;
    dataSubscription: Subscription;
    loading: boolean = true;
    notes: PageView[] = [];

    constructor(private readonly onBehalfService: FlowOnBehalfService) { }

    ngOnInit() {
        this.loading = true;
        this.dataSubscription = this.onBehalfService.getClarificationNotes(this.instanceId).pipe(
            tap((data: PageView[]) => { this.notes = data; })
        )
            .subscribe((data) => { this.loading = false; }, (error) => { console.error(error); });
    }

    ngOnDestroy() {
        if (this.dataSubscription) this.dataSubscription.unsubscribe();
    }
}

